// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1cSIA","inputWrap":"Table_inputWrap__1520q","col":"Table_col__v3a3a","bmiTooltip":"Table_bmiTooltip__Svsa9"};